declare global {
    interface Window {
        LYW?: {
            maintenance?: boolean;
            PaddleCountryCode?: string;
        };
    }
}

/** Maps ISO 3166-1 alpha-2 country codes to BCP 47 locales for date display. */
const COUNTRY_TO_LOCALE: Record<string, string> = {
    GB: 'en-GB',
    IE: 'en-IE',
    AU: 'en-AU',
    NZ: 'en-NZ',
    US: 'en-US',
    CA: 'en-CA',
    IN: 'en-IN',
    ZA: 'en-ZA',
    SG: 'en-SG',
};

const DEFAULT_DISPLAY_LOCALE = 'en-GB';

export function getDetectedCountryCode(): string | undefined {
    if (typeof window === 'undefined') return undefined;
    return window.LYW?.PaddleCountryCode;
}

export function getDisplayLocale(countryCode?: string | null): string {
    if (countryCode && COUNTRY_TO_LOCALE[countryCode]) {
        return COUNTRY_TO_LOCALE[countryCode];
    }
    return DEFAULT_DISPLAY_LOCALE;
}

export function getDetectedDisplayLocale(): string {
    return getDisplayLocale(getDetectedCountryCode());
}
